import { DateTime } from 'luxon';

import { Util } from '@finley-technologies/finley-types';

import {
  ChartTimePeriod,
  formatChartDataByReportingDate,
} from 'packages/portfolio/ui/shared/portfolioChartUtils';

// @dmads98 consider moving to common/frontend as part of utils
export const getRecordsForDateRangeAndTimePeriod = (
  records: {
    reportingDate: Util.FullDateStr;
    fileVersion: number;
    [key: string]: Util.Primitive;
  }[],
  startDate: Date,
  endDate: Date,
  selectedTimePeriod: ChartTimePeriod,
) => {
  const filteredRecords = records.filter((record) => {
    const reportingDate = DateTime.fromISO(record.reportingDate).toJSDate();
    return reportingDate >= startDate && reportingDate <= endDate;
  });
  return formatChartDataByReportingDate({
    chartData: filteredRecords,
    selectedTimePeriod,
  });
};
